var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMagic = function SvgMagic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m10.15 10.339-1.476 3.1a.4.4 0 0 1-.652.103l-2.36-2.493a.4.4 0 0 0-.239-.121l-3.404-.445a.4.4 0 0 1-.3-.588L3.36 6.879a.4.4 0 0 0 .042-.264L2.773 3.24a.4.4 0 0 1 .467-.467l3.375.63a.4.4 0 0 0 .264-.043l3.016-1.64a.4.4 0 0 1 .588.299l.445 3.404a.4.4 0 0 0 .121.239l2.493 2.36a.4.4 0 0 1-.103.652l-3.1 1.475a.4.4 0 0 0-.19.19Zm.53 1.284.943-.942 2.829 2.828-.943.943-2.829-2.829Z"
  })));
};
export default SvgMagic;